import { BinTypes } from '../domain/analytics/BinTypes';
import { DateChartAnalytics } from '../domain/analytics/dataChartAnalytics/DateChartAnalytics';
import { StopAnalyticsDateChartData } from '../domain/analytics/stopAnalyticsDateChartData/StopAnalyticsDateChartData';
import { analyticsRepository } from '../repositories/analytics';
import { AnalyticsRepository } from '../repositories/analytics/AnalyticsRepository';

export class AnalyticsService {
  constructor(private analyticsRepository: AnalyticsRepository) {}

  async getAnalyticsEmissions({
    startDate,
    endDate,
    binType,
  }: {
    startDate: Date;
    endDate: Date;
    binType: BinTypes;
  }): Promise<DateChartAnalytics[]> {
    return this.analyticsRepository.getAnalyticsEmissions({ startDate, endDate, binType });
  }

  async getAnalyticsDistance({
    startDate,
    endDate,
    binType,
  }: {
    startDate: Date;
    endDate: Date;
    binType: BinTypes;
  }): Promise<DateChartAnalytics[]> {
    return this.analyticsRepository.getAnalyticsDistance({ startDate, endDate, binType });
  }

  async getAnalyticsStops({
    startDate,
    endDate,
    binType,
  }: {
    startDate: Date;
    endDate: Date;
    binType: BinTypes;
  }): Promise<StopAnalyticsDateChartData[]> {
    return this.analyticsRepository.getAnalyticsStops({ startDate, endDate, binType });
  }
}

export const analyticsService = new AnalyticsService(analyticsRepository);
